import { Controller } from "@hotwired/stimulus"

// Blocks paste/drop so the user must retype (e.g. email confirmation).
export default class extends Controller {
  prevent(event) {
    event.preventDefault()
  }
}
